import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";

import { ANNUAL_SURVEY_DEFAULT_TITLE } from "lib/constants";
import { AssignmentTurnedInOutlined } from "common/DS/Icons";
import { Body1 } from "common/DS/Text";
import ZeroState from "common/DS/ZeroState";

const SurveyClosedHelperText = ({ endDate, companyName }, { t: _ }) => {
    const formattedDate = <strong>{moment(endDate).format("MMM DD, YYYY")}</strong>;
    const beginningText = (
        <p>
            {_(
                `Thank you for your interest, however this survey has stopped accepting responses on {date}`,
                { date: formattedDate },
            )}
            .
        </p>
    );
    const endText = (
        <p>
            {_(`Try contacting {company} if you think this is a mistake.`, {
                company: companyName,
            })}
        </p>
    );
    return (
        <Body1>
            {beginningText}
            {endText}
        </Body1>
    );
};

SurveyClosedHelperText.contextTypes = {
    t: PropTypes.func,
};

SurveyClosedHelperText.propTypes = {
    endDate: PropTypes.string,
    companyName: PropTypes.string,
};

SurveyClosedHelperText.defaultProps = {
    endDate: "",
    companyName: "",
};

const localRenderLanguageSelect = (renderLanguageSelect) => {
    if (renderLanguageSelect) {
        return renderLanguageSelect();
    }
    return null;
};

const SurveyIcon = <AssignmentTurnedInOutlined />;

const CheckInClosed = ({ checkinTitle, endDate, companyName, renderLanguageSelect }) => (
    <>
        <ZeroState
            icon={SurveyIcon}
            title={checkinTitle}
            helperTextComponent={
                <SurveyClosedHelperText endDate={endDate} companyName={companyName} />
            }
            additionalClassName="check-in__zero-state"
        />
        {localRenderLanguageSelect(renderLanguageSelect)}
    </>
);

CheckInClosed.propTypes = {
    checkinTitle: PropTypes.string,
    endDate: PropTypes.string, // Double check what we use for datetimes
    companyName: PropTypes.string,
    renderLanguageSelect: PropTypes.func.isRequired,
};

CheckInClosed.defaultProps = {
    checkinTitle: ANNUAL_SURVEY_DEFAULT_TITLE,
    endDate: "",
    companyName: "",
};

export default CheckInClosed;
